import { Col, Row, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { Api, updateGames } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GamePanel, Header } from 'screens/Admin/components';
import { Filters, List } from './components';
import { endOfDay, startOfDay } from 'date-fns';

let timer, interval;
const Users = ({}) => {
  const [status, setStatus] = useState({
      value: 'All Statuses',
      opt: undefined
    }),
    [sport, setSport] = useState({ value: 'All' }),
    [dataId, setDataId] = useState(null),
    [sortBy, setSortBy] = useState({ date: -1 }),
    [loading, setLoading] = useState(true),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch(),
    games = useSelector((state) => state.admin?.games?.filter((x) => x)),
    fetching = useRef(false),
    skip = useRef(0),
    scrollId = 'admin-games-list';

  useInfiniteScroll(scrollId, getGames, { sport, sortBy, status });

  useEffect(() => {
    return () => {
      clearTimeout(timer);
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    clearTimeout(timer);
    clearInterval(interval);

    getGames(true);
    updateGames('admin');
    interval = setInterval(() => {
      updateGames('admin');
    }, 30000);
  }, [status, sport]);

  useEffect(() => {
    skip.current = games?.length || 0;
  }, [games]);

  async function getGames(isFilterChange) {
    if (isFilterChange) {
      dispatch({
        type: 'ADMIN_SET_GAMES',
        payload: null
      });
    }

    if (fetching.current) return;
    fetching.current = true;

    const requestBody = {
      offset: isFilterChange ? 0 : skip.current,
      limit: 30,
      sortBy
    };

    // Add sport filter if not 'All'
    if (sport.opt) {
      requestBody.sport = sport.opt;
    }

    // Add status filter if selected
    if (status.opt && status.opt !== 'today') {
      requestBody.status = status.opt;
    }
    if (status.opt === 'today') {
      requestBody.startDate = startOfDay(new Date()).toISOString();
      requestBody.endDate = endOfDay(new Date()).toISOString();
    }

    const res = await Api.post('/admin/games/get', requestBody);

    if (!res) return (fetching.current = false);

    // Handle new response structure { total, games }
    const games = res.games || [];

    dispatch({
      type: 'ADMIN_ADD_GAMES',
      payload: games
    });

    fetching.current = false;
    setLoading(false);

    return games.length;
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Games</Text>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <Filters
          className="filters"
          status={status}
          setStatus={setStatus}
          sport={sport}
          setSport={setSport}
        />

        {!loading && (
          <List
            onClick={(gameId) => setDataId(gameId)}
            dataId={dataId}
            data={games}
            loading={loading}
          />
        )}
      </Col>

      <GamePanel dataId={dataId} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Users;
